import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    display: "flex",
    flexDirection: "column",
  },
  tableTitle: {
    fontWeight: 600
  },
  tableHeader: {
    fontWeight: 600,
    fontSize: 12
  },
  tableBody: {
    fontSize: 12
  },
  textAlignRight: {
    textAlign: "right",
    paddingRight: 12
  }
}));

export default useStyles;
